import { render, staticRenderFns } from "./AIAvatarContentEditionPanel.vue?vue&type=template&id=272812c3&scoped=true"
import script from "./AIAvatarContentEditionPanel.vue?vue&type=script&lang=ts"
export * from "./AIAvatarContentEditionPanel.vue?vue&type=script&lang=ts"
import style0 from "./AIAvatarContentEditionPanel.vue?vue&type=style&index=0&id=272812c3&prod&lang=scss"
import style1 from "./AIAvatarContentEditionPanel.vue?vue&type=style&index=1&id=272812c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272812c3",
  null
  
)

export default component.exports